(() => {
  const root = document.querySelector('[data-preview-funnel]');
  if (!root) return;
  const daily = root.dataset.offer === 'quotidien';
  const checkoutData = root.querySelector('[data-quotidien-checkout]');
  const checkout = checkoutData ? JSON.parse(checkoutData.textContent) : null;
  const errorOutput = root.querySelector('[data-checkout-error]');
  let submitting = false;
  const money = cents => (cents / 100).toLocaleString('fr-FR', {style:'currency',currency:'EUR'});
  const selected = group => root.querySelector(`[data-group="${group}"].is-selected`);
  const set = (selector,value) => root.querySelectorAll(selector).forEach(el => {el.textContent=value;});
  function selection() {
    const size=selected('size');
    const cents=Number(size.dataset.cents);
    const delivery=daily?root.querySelector('[name="quotidien-delivery"]:checked').value:'relay';
    return {size,cents,first:daily?cents:Math.round(cents*.5),delivery,shipping:delivery==='home'?790:Number(size.dataset.shipping),ground:selected('format').dataset.label==='Moulu'};
  }
  function update() {
    const {size,cents,first,shipping,ground,delivery}=selection();
    root.querySelector('[data-step="brew"]').classList.toggle('is-hidden',!ground);
    root.querySelectorAll('[data-group]').forEach(el=>el.setAttribute('aria-pressed',String(el.classList.contains('is-selected'))));
    set('[data-summary-format]',ground?`Moulu · ${selected('brew').dataset.label}`:'En grains');
    if(!daily) set('[data-summary-style]',selected('style').dataset.label);
    set('[data-summary-quantity]',size.dataset.quantity);
    set('[data-summary-delivery]',delivery==='home'?'Domicile':'Point relais');
    set('[data-summary-price-first],[data-dock-price]',money(first));
    set('[data-summary-price]',money(cents));
    set('[data-shipping-copy]',shipping?`Livraison : ${money(shipping)}`:'Livraison offerte');
    set('[data-dock-shipping]',shipping?`+ ${money(shipping)} ${delivery==='home'?'à domicile':'en relais'}`:'Livraison offerte');
    if(daily) {
      set('[data-relay-option-price]',Number(size.dataset.shipping)?`${money(Number(size.dataset.shipping))}`:'offert');
      root.querySelector('[data-relay-after-payment]').hidden=delivery!=='relay';
    }
    set('[data-relay-total]',money(first+shipping));
    root.querySelector('[data-total-line]').hidden=shipping===0;
    root.dataset.croSelectionValid='yes';
    root.dispatchEvent(new CustomEvent('anom:summary-updated',{bubbles:true}));
  }
  root.querySelectorAll('.js-funnel-choice').forEach(button=>button.addEventListener('click',()=>{
    root.querySelectorAll(`[data-group="${button.dataset.group}"]`).forEach(el=>el.classList.remove('is-selected'));
    button.classList.add('is-selected');
    update();
  }));
  root.querySelectorAll('[name="quotidien-delivery"]').forEach(input=>input.addEventListener('change',update));
  root.querySelectorAll('[data-faq-link]').forEach(link=>link.addEventListener('click',()=>{
    const details=document.querySelector(link.hash);
    if(details) details.open=true;
  }));
  const dialog=root.querySelector('[data-funnel-dialog]');
  root.querySelector('.js-funnel-submit').addEventListener('click',async()=>{
    if(daily) {
      if(submitting) return;
      const buttons=root.querySelectorAll('.js-funnel-submit,[data-dock-submit]');
      errorOutput.hidden=true;
      submitting=true;
      buttons.forEach(button=>{button.disabled=true;button.setAttribute('aria-busy','true');});
      const diagnosticStart=performance.now();
      let diagnosticStage='selection';
      const diagnose=name=>window.AnomFunnelDiagnostics?.emit(name,diagnosticStage,performance.now()-diagnosticStart);
      diagnose('checkout_start');
      const diagnosticTimer=setTimeout(()=>diagnose('checkout_slow'),5000);
      try {
        const {size,cents,ground,delivery}=selection();
        const planId=checkout?.planIds?.[delivery];
        const grind=ground?selected('brew').dataset.label:'En grains';
        const variant=checkout?.variants.find(item=>item.size===size.dataset.quantity&&item.grind===grind);
        const allocation=variant?.plans.find(plan=>plan.id===planId);
        if(checkout?.productId!==16580881842444||!planId||!variant?.available||variant.price!==cents||allocation?.price!==cents) {
          throw new Error('Cette sélection est momentanément indisponible. Merci de réessayer dans quelques instants.');
        }
        diagnosticStage='cart_read';
        const cartResponse=await fetch('/cart.js',{cache:'no-store'});
        if(!cartResponse.ok) throw new Error('Votre panier ne peut pas être vérifié. Veuillez réessayer.');
        const cart=await cartResponse.json();
        const cartGuard=window.AnomQuotidienCart;
        if(!cartGuard||!Array.isArray(cart.items)) throw new Error('Votre panier ne peut pas être vérifié. Veuillez réessayer.');
        const managed=cartGuard.managedItems(cart);
        if(managed.length>1) throw new Error('Plusieurs sélections Quotidien sont présentes. Vérifiez cet abonnement dans votre panier avant de continuer.');
        const previous=managed[0];
        const quantity=previous?.quantity||1;
        if(!previous||!cartGuard.matches(previous,variant.id,planId)) {
          diagnosticStage='cart_add';
          const response=await fetch('/cart/add.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:variant.id,quantity,selling_plan:planId,properties:{'_anom_funnel_key':'quotidien-main','Café':'Blend Signature ANOM','Offre':'Quotidien','Rythme':'Mensuel','Livraison récurrente':delivery==='home'?'Mondial Relay domicile - 7,90 € par mois':'Point relais Mondial Relay'}}]})
          });
          const result=await response.json();
          if(!response.ok) throw new Error(result.description||'Votre abonnement n’a pas pu être ajouté. Veuillez réessayer.');
          diagnosticStage='cart_verify';
          const verifiedResponse=await fetch('/cart.js',{cache:'no-store'});
          if(!verifiedResponse.ok) throw new Error('Le panier doit être vérifié avant le paiement. Merci de nous contacter.');
          const addedCart=await verifiedResponse.json();
          if(!cartGuard.verifyAdded(cart,addedCart,variant.id,planId,cents,quantity)) throw new Error('Le panier doit être vérifié avant le paiement. Merci de nous contacter.');
          if(previous) {
            const currentPrevious=addedCart.items.find(item=>cartGuard.sameLine(item,previous));
            diagnosticStage='cart_change';
            const changed=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:currentPrevious.key,quantity:0})});
            if(!changed.ok||!cartGuard.verifyAdded({items:cart.items.filter(item=>item!==previous)},await changed.json(),variant.id,planId,cents,quantity)) throw new Error('Votre nouvelle sélection est ajoutée, mais la précédente doit être vérifiée dans votre panier.');
          }
        }
        diagnose('checkout_redirect');
        window.location.assign('/checkout');
      } catch(error) {
        diagnose('checkout_error');
        errorOutput.textContent=error.message||'Une erreur est survenue. Veuillez réessayer.';
        errorOutput.hidden=false;
      } finally {
        clearTimeout(diagnosticTimer);
        submitting=false;
        buttons.forEach(button=>{button.disabled=false;button.removeAttribute('aria-busy');});
      }
      return;
    }
    const {size,cents,first,shipping}=selection();
    const lines=[`ANOM ${daily?'Quotidien · Signature':'Découverte'}`,`${size.dataset.quantity} · ${root.querySelector('[data-summary-format]').textContent}`];
    if(!daily) lines.push(selected('style').dataset.label);
    lines.push(daily?`Café : ${money(cents)} par commande, sans remise temporaire.`:`Café : ${money(first)} au premier envoi, puis ${money(cents)}.`,shipping?`Point relais : ${money(shipping)}.`:'Point relais offert.',`Total avec relais : ${money(first+shipping)}.`,`Domicile : ${daily?'7,90':'6,90'} € de livraison. Choix au paiement.`);
    const output=root.querySelector('[data-funnel-selection]');
    output.replaceChildren(...lines.map(text=>{const p=document.createElement('p');p.textContent=text;return p;}));
    dialog.showModal();
  });
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close();}});
  update();
  const rail=root.querySelector('[data-quantity-rail]');
  const navigation=root.querySelector('[data-quantity-navigation]');
  const previous=root.querySelector('[data-quantity-prev]');
  const next=root.querySelector('[data-quantity-next]');
  function updateNavigation() {
    const max=rail.scrollWidth-rail.clientWidth;
    navigation.hidden=max<=2;
    previous.disabled=rail.scrollLeft<=2;
    next.disabled=rail.scrollLeft>=max-2;
  }
  const center=()=>{const card=selected('size');rail.scrollLeft=card.offsetLeft-rail.offsetLeft-(rail.clientWidth-card.clientWidth)/2;updateNavigation();};
  function scrollQuantity(direction) {
    const card=rail.querySelector('[data-group="size"]');
    const step=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0);
    rail.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  previous.addEventListener('click',()=>scrollQuantity(-1));
  next.addEventListener('click',()=>scrollQuantity(1));
  rail.addEventListener('scroll',updateNavigation,{passive:true});
  if(window.ResizeObserver) new ResizeObserver(updateNavigation).observe(rail);
  requestAnimationFrame(center);
  document.fonts?.ready.then(center);
})();
